import React, { Component } from 'react';
import {
    Button,
    Modal,
    ModalBody, ModalFooter,
    ModalHeader,
 } from 'reactstrap';
import { Link } from 'react-router-dom';
import dictionary from '../../utils/dictionary';
import HealthStatus from '../../components/HealthStatus';

class AssignedGateway extends Component {
    constructor(props) {
        super(props);
        this.state = {
            delete: false,
            ...this.props.data,
        };
        this.renderGatewayType = this.renderGatewayType.bind(this);
    }

    renderGatewayType() {
        let types = this.state.type;

        switch (types) {
            case "CHECK_IN":
                return "Check In";
            case "CHECK_OUT":
                return "Check Out";
            case "CHECK_IN_OUT":
                return "Check In/Out";
            case "MIDGATEWAY":
                return "Zwischentür";
            case "MIDGATEWAY_ONLINE":
                return "Zwischentür (Online)";
            case "MIDGATEWAY_OFFLINE":
                return "Zwischentür (Offline)";
            case "NFC_WRITE":
                return "NFC Gateway";
            case "EXIT_BARRIER":
                return "Ausfahrtsschranken";
            case "EXIT_BARRIER_ONLINE":
                return "Ausfahrtsschranken (Online)";
            case "EXIT_BARRIER_OFFLINE":
                return "Ausfahrtsschranken (Offline)";
            case "REPEATER":
                return "Signalverstärker";
            default:
                return "k.A";
        }
    }

    renderHealthStyle(data) {
        if (data.health_status) {
            return <HealthStatus healthStatus={data.health_status} />
        }

        const status = data.state;
        let state = status.toLowerCase();

        const color = state === 'online' ? 'text-success' : state === 'attention' ? 'text-warning' : 'text-danger';
        return <div><i className={`fa fa-circle ${color} Blink`} />{status}</div>
    }

    toggleDelete() {
        this.setState({
            delete: !this.state.delete,
        });
    }

    removeGateway() {
        this.props.removeGateway(this.state.id)
            .then((response) => {
                console.log(response);
            })
            .catch((err) => {
                console.log(err);
            })
    }
    render() {
        console.log(this.state)
        return (
            <tr>
                {!this.props.newGateway && !this.props.newPCGateway && <td><Link to={"/gateways/" + this.state.id}>{this.state.id}</Link></td>}
                {!!this.props.newGateway && <td><Link to={`/${this.state.gateway_type === 'SALTO' ? `salto/${this.state.id}` : `gateways2/${this.state.gwid}`}`}>{this.state.gwid}</Link></td>}
                {!!this.props.newPCGateway && <td><Link to={"/payuca-connect/" + this.state.id}>{this.state.id}</Link></td>}
                <td>{this.state.name || dictionary.NOT_AVAILABLE}</td>
                <td>{this.state.device_id || dictionary.NOT_AVAILABLE}</td>
                <td>{this.renderGatewayType()}</td>
                <td>
                    {this.renderHealthStyle(this.state)}
                </td>
                {(!!this.props.newGateway || !!this.props.newPCGateway) &&
                    <td>
                        {`${(this.state.is_master || !this.state.master_id) ? "Ja" : "Nein"}`}
                    </td>
                }
                <td>
                    <Button className="btn btn-sm btn-danger pull-right" onClick={this.toggleDelete.bind(this)}>
                        Aufheben
                    </Button>
                {/* Modals */}

                {/* Delete user */}
                <Modal isOpen={this.state.delete} toggle={this.toggleDelete.bind(this)}
                       className={'modal-danger ' + this.props.className}>
                    <ModalHeader toggle={this.toggleDelete.bind(this)}>Gateway wirklich deaktivieren?</ModalHeader>
                    <ModalBody>
                        Wenn du dieses Gateway deaktivierst, sind Check-In und Check-Out nicht mehr möglich.<br />
                        Kund:innen können nicht mehr einfahren oder ausfahren - das führt zu Supportfällen und Umsatzverlust.<br />
                        <br />
                        Bitte nur deaktivieren, wenn es technisch zwingend notwendig ist.
                    </ModalBody>
                    <ModalFooter>
                        <Button color="danger" onClick={this.removeGateway.bind(this)}>Deaktivierung bestätigen</Button>{' '}
                        <Button color="secondary" onClick={this.toggleDelete.bind(this)}>Abbrechen</Button>
                    </ModalFooter>
                </Modal>

                </td>
            </tr>
        );
    }
}

export default AssignedGateway;
